module.exports = __webpack_public_path__ + "static/media/icon-getty.c64b96b5.svg";